module.exports = __webpack_public_path__ + "static/media/29EUNOG3.e7f09c3e.jpg";